import {
  AGE_END,
  AGE_START,
  BASE,
  BRANDS,
  BUTTERLFY,
  DIFFERENTIATION,
  FILTERS,
  GROUPED_BY,
  MARKETS,
  MODE,
  PERCEPTUAL,
  PERIOD,
  PERIOD_END_DATE,
  PERIOD_START_DATE,
  PERIOD_TYPE,
  POINT_IN_TIME,
  POST_END_DATE,
  POST_PERIOD_TYPE,
  POST_START_DATE,
  PROFILE,
  PROFILE_GROUP,
  PROFILE_RESPONSE,
  PROFILE_METRIC,
  QUESTION_OPTIONS,
  SCORE_TYPE,
  SECONDARY_BRANDS,
  SEGMENTS,
  STAT_TEST,
  TRENDS_METRIC,
  VIEW_ID,
  VISUALIZATION_TYPE,
  TRENDS_RESPONSE,
  URL_BY_BRAND,
} from "@/constant/constantsThrougoutProject";
import { ROUTES_CHILDREN_LOOKUP } from "@/routes/routes";
import { DateTime } from "luxon";
import { STAT_TESTING_OPTIONS } from "@/components/projectCommon/StatTesting/StatTesting.constant";
import { BASE_OPTIONS } from "@/components/dropdown/BaseDropdown/constant.BaseDropdown";
import { MODE_OPTIONS } from "@/components/dropdown/ModeDropdown/constant.ModeDropdown";
import { PERIOD_KEYS } from "@/components/dropdown/PeriodDropdown/constant.PeriodDropdown";

export function getUpdateUrlParameters(
  pathname: string,
  params: any,
  userSelection: any,
  activeGroupData: any,
) {
  const currentPathConfig = ROUTES_CHILDREN_LOOKUP[pathname];
  const finalParams: Record<string, any> = {};

  let mode: string =
    typeof params?.mode === "string" ? params?.mode : "POINT_IN_TIME";
  if (
    mode === POINT_IN_TIME &&
    (params?.visualizationType === PERCEPTUAL ||
      params?.visualizationType === BUTTERLFY ||
      params?.visualizationType === DIFFERENTIATION ||
      params?.visualizationType === PROFILE)
  ) {
    mode = params.visualizationType;
  }
  currentPathConfig?.urlKeysMapping?.[
    (currentPathConfig?.modeOptions?.includes(mode) && mode) || "POINT_IN_TIME"
  ]?.forEach((key: string) => {
    if (key === MARKETS) {
      const markets = params[key];
      let result: number[] = [];
      if (markets && markets?.length > 0) {
        result = markets;
      }
      result = result?.filter((marketId: number) =>
        activeGroupData?.markets?.includes(marketId),
      );
      if (result?.length === 0) {
        result = activeGroupData?.markets;
      }
      finalParams[key] = result;
    } else if (key === BRANDS) {
      const brands = params[key];
      let result: number[] = [];
      if (brands && brands?.length > 0) {
        result = brands;
      }
      result = result?.filter((brandId: number) =>
        activeGroupData?.brands?.includes(brandId),
      );
      if (result?.length === 0 && !pathname.startsWith("/reputation")) {
        result = activeGroupData?.brands;
      }
      finalParams[key] = result;
    } else if (key === SECONDARY_BRANDS) {
      const brands = params[key];
      let result: number[] = [];
      if (brands && brands?.length > 0) {
        result = brands;
      }
      result = result?.filter(
        (brandId: number) =>
          activeGroupData?.brands?.includes(brandId) &&
          !finalParams["brands"]?.includes(brandId),
      );
      if (result?.length === 0) {
        result = activeGroupData?.brands
          ?.filter(
            (brandId: number) => !finalParams["brands"]?.includes(brandId),
          )
          ?.slice(0, 1);
      }
      finalParams[key] = result;
    } else if (key === FILTERS) {
      const filters = params[key] || [];
      finalParams[key] = filters;
    } else if (key === SEGMENTS) {
      if (
        currentPathConfig?.useSegmentSelect &&
        activeGroupData?.segments?.length > 0
      ) {
        finalParams[key] =
          params[key]?.filter((id: number) =>
            activeGroupData?.segments?.includes(id),
          ) || [];
        if (finalParams[key]?.length === 0) {
          finalParams[key] = activeGroupData?.activeSegments;
          if (finalParams[key]?.length === 0) {
            finalParams[key] = [activeGroupData.ageSegmentId];
          }
        }
      } else {
        const segments = params[key] || [];
        finalParams[key] = segments;
      }
    } else if (key === STAT_TEST) {
      if (
        STAT_TESTING_OPTIONS?.map((stat) => stat.id)?.includes(params[key]) ||
        params[key] === "NONE"
      ) {
        finalParams[key] = params[key];
      } else {
        finalParams[key] = "POP";
      }
    } else if (key === BASE) {
      const filteredBaseOptions = BASE_OPTIONS.filter(
        (b) => !currentPathConfig.disableBases?.includes(b.value as string),
      );
      if (
        filteredBaseOptions?.filter((val) => val?.value === params[key])
          ?.length > 0
      ) {
        finalParams[key] = params[key];
      } else {
        finalParams[key] = filteredBaseOptions?.[0]?.value;
      }
    } else if (key === MODE) {
      if (MODE_OPTIONS?.map((m) => m.value)?.includes(params[key])) {
        finalParams[key] = params[key];
      } else {
        finalParams[key] = POINT_IN_TIME;
      }
    } else if (key === QUESTION_OPTIONS) {
      const questionOptions = params[key] || [];
      finalParams[key] = questionOptions;
    } else if (key === PERIOD_TYPE || key === POST_PERIOD_TYPE) {
      if (params[key]) {
        finalParams[key] = params[key];
      } else {
        finalParams[key] = "L180D";
      }
    } else if (
      key === PERIOD_START_DATE ||
      key === POST_START_DATE ||
      key === POST_END_DATE ||
      key === PERIOD_END_DATE
    ) {
      if (params[key]?.length === 8) {
        finalParams[key] = DateTime.fromFormat(
          params[key],
          "yyyyMMdd",
        ).toFormat("yyyy-MM-dd");
      } else if (params[key]?.length === 10) {
        finalParams[key] = params[key];
      } else {
        finalParams[key] = userSelection[key];
      }
    } else if (key === PERIOD) {
      if (PERIOD_KEYS?.includes(params[key])) {
        finalParams[key] = params[key];
      } else {
        finalParams[key] = userSelection?.[PERIOD] ?? "MV_12";
      }
    } else if (key === GROUPED_BY) {
      if (params[key]) {
        finalParams[key] = params[key];
      } else {
        finalParams[key] = "RESPONSE";
      }
    } else if (key === SECONDARY_BRANDS) {
    } else if (
      key === TRENDS_METRIC ||
      key === TRENDS_RESPONSE ||
      key === VIEW_ID ||
      key === SCORE_TYPE ||
      key === VISUALIZATION_TYPE ||
      key === AGE_START ||
      key === AGE_END
    ) {
      if (params[key]) {
        finalParams[key] = params[key];
      }
    } else if (
      key === PROFILE_GROUP ||
      key === PROFILE_METRIC ||
      key === PROFILE_RESPONSE
    ) {
      if (params[key]) {
        finalParams[key] = !isNaN(params[key])
          ? Number(params[key])
          : params[key];
      }
    }
  });

  const urlParams = new URLSearchParams();
  currentPathConfig?.urlKeysMapping?.[
    (currentPathConfig?.modeOptions?.includes(mode) && mode) || "POINT_IN_TIME"
  ]?.forEach((key: string) => {
    if (
      key === MARKETS ||
      key === BRANDS ||
      key === FILTERS ||
      key === SECONDARY_BRANDS ||
      key === SEGMENTS ||
      key === QUESTION_OPTIONS
    ) {
      if (finalParams[key]?.length > 0) {
        finalParams[key]?.map((val: any) => urlParams.append(key, val));
      }
    } else if (finalParams[key]) {
      urlParams.append(key, finalParams[key]);
    }
  });
  return urlParams?.toString();
}
